import { render, staticRenderFns } from "./SearchDropdown.vue?vue&type=template&id=40aa8a0c&scoped=true&"
import script from "./SearchDropdown.vue?vue&type=script&lang=js&"
export * from "./SearchDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SearchDropdown.vue?vue&type=style&index=0&id=40aa8a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40aa8a0c",
  null
  
)

export default component.exports